import {
 
    PROVIDER_GET_REQUEST,
    PROVIDER_GET_FAILURE,
    PROVIDER_GET_SUCCESS
} from "../actions/actionTypes";

const initialState = {
    providers: [],
    loading: false,
    error: null,
};

const providerReducer = (state = initialState, action) => {
    switch (action.type) {
        case PROVIDER_GET_REQUEST:
            return { ...state, loading: true, error: null };
        case PROVIDER_GET_SUCCESS:
            return { ...state, loading: false, providers: action.payload.data };
        case PROVIDER_GET_FAILURE:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default providerReducer;
